/* eslint-disable no-bitwise */
/* eslint-disable space-infix-ops */
/* eslint-disable prefer-const */
/* eslint-disable camelcase */

import { isEqual } from 'lodash';
import { formatPhoneNumber, formatEmailAddress, changePhoneNumberFormat, setAction, trimString } from './shared';

export const formatDwellingIncident = (formData) => {
  const outDoorOtherStructure = new Set([
    'greenhouse',
    'gardenStructure',
    'pool',
    'shedOrBuilding',
    'garage',
  ]);
  // room damage && otherStructures
  if (formData.interior?.interiorRoomsInfo) {
    let roomDamage = [];
    formData.interior.interiorRoomsInfo.forEach((room) => {
      roomDamage.push({
        roomType: room.pickARoomToTellUsAbout,
        aspectsDamaged: room.selectAllTheDamagedAreas?.selectedValues,
      });
    });
    formData.roomDamage = roomDamage;
  }
  // exterior damage && other structures
  if (formData.exterior?.damagedAreas?.selectedValues) {
    let exteriorDamage = [];
    let outbuildingDamaged_Ext = [];
    formData.exterior.damagedAreas.selectedValues.forEach((area) => {
      if (outDoorOtherStructure.has(area)) {
        outbuildingDamaged_Ext.push({
          type: 'hardCoded',
          areaDamage: area,
          materialDamaged: 'hardCoded',
        });
      } else {
        exteriorDamage.push({
          type: 'extdamage',
          areaDamage: area,
          materialDamaged: 'hardCoded',
        });
      }
    });
    if (exteriorDamage.length > 0) {
      formData.exteriorDamage = exteriorDamage;
    }
    if (outbuildingDamaged_Ext.length > 0) {
      formData.outbuildingDamaged_Ext = outbuildingDamaged_Ext;
    }
  }
};

export const formatLostDamagedItems = (formData) => {
  let lostDamagedItems = [];
  const items = formData.typeMissingItems?.selectedValues || formData.typeStolenItems?.selectedValues || formData.belongings?.damagedItemsFire?.selectedValues || formData.belongings?.damagedItemsWindHail?.selectedValues || formData.belongings?.damagedItemsWater?.selectedValues;
  if (items) {
    items.forEach((item) => {
      lostDamagedItems.push({
        category: item,
      });
    });
  }
  const specialtyItems = formData.specialtyItemsStolenOrLost?.selectedValues;
  if (specialtyItems) {
    specialtyItems.forEach((item) => {
      lostDamagedItems.push({
        other: item.description,
        category: 'scheduledItems',
        estimatedValue: item.estimatedValue.toString(),
      });
    });
  }
  if (lostDamagedItems.length > 0) {
    formData.lostDamagedItems = lostDamagedItems;
  }
};

export const formatPropertyIncidents = (formData) => {
  const incidents = ['dwellingIncident', 'propertyContentsIncident', 'otherStructureIncident'];
  incidents.forEach((incident) => {
    if (formData[incident]) {
      const data = formData[incident];
      if (data.id) {
        data.action = 'patch';
        delete data.temporaryId;
      } else if (data.temporaryId) {
        data.action = 'post';
        delete data.id;
      }
      const keys = new Set(Object.keys(data));
      const patchPayloadKeys = new Set(['action', 'id']);
      const postPayloadKeys = new Set(['action', 'temporaryId']);
      if (isEqual(keys, patchPayloadKeys) || isEqual(keys, postPayloadKeys)) {
        // delete the incident if there is no attributes other than id/temporaryId and action
        delete formData[incident];
      } else {
        // wrap the incident as an array as requested by MS.
        formData[incident] = [formData[incident]];
      }
    }
  });
};

export const formatContactInfoProp = (formData) => {
  let contact = [];
  const policyHolderExist = formData.policyHolder && Object.keys(formData.policyHolder).length !== 0;
  const reporterExist = formData.newReporter && formData.reporter && Object.keys(formData.reporter).length !== 0;
  // add policy holder contact info
  if (policyHolderExist) {
    let policyHolderInfo = formData.policyHolder;
    policyHolderInfo.type = 'person';
    policyHolderInfo.role = ['policyholder', 'insured'];
    formatEmailAddress(policyHolderInfo);
    formatPhoneNumber(policyHolderInfo);

    // get name from browser storage
    const policySessionStorage = JSON.parse(window.sessionStorage.getItem('thePolicy'));
    if (policySessionStorage) {
      policyHolderInfo.firstName = policySessionStorage.insured?.firstName;
      policyHolderInfo.lastName = policySessionStorage.insured?.lastName;
    }
    delete policyHolderInfo.vehicleIncidentTempId;
    setAction(policyHolderInfo);
    contact.push(policyHolderInfo);
  }
  // add reporter contact info
  if (reporterExist) {
    const defaultProvince = JSON.parse(sessionStorage.getItem('thePolicy'))?.policyLocation?.[0]?.provinceCode;
    formData.reporter.type = 'person';
    formData.reporter.role = ['altcontact'];
    formData.reporter.comments = formData.reporter.relationshipToPolicyHolder;
    formData.reporter.address = {
      streetNumber: 'Unknown',
      streetName: 'Unknown',
      city: 'Unknown',
      countryCode: 'CA',
      provinceCode: defaultProvince,
      postalCode: 'X0X 0X0',
    };
    formData.reporter.firstName = formData.reporter.firstName || 'Unknown';
    formData.reporter.lastName = formData.reporter.lastName || 'Unknown';
    formData.reporter.consent = formData.reporter.iAmNotThePolicyHolder || false;
    delete formData.reporter.relationshipToPolicyHolder;
    delete formData.reporter.iAmNotThePolicyHolder;
    formatPhoneNumber(formData.reporter);
    formatEmailAddress(formData.reporter);
    setAction(formData.reporter);
    contact.push(formData.reporter);
  }
  if (formData.contactCleaningDamages) {
    let cleaningCompany = {
      type: 'CompanyVendor',
      role: ['vendor'],
      companyName: trimString(formData.assistCleaningDamages?.company) || 'Unknown',
      phoneNumber: {
        code: 'CA',
        number: changePhoneNumberFormat(formData.assistCleaningDamages.number) || '999-999-9999',
      },
      id: formData.assistCleaningDamages?.id,
      temporaryId: formData.assistCleaningDamages?.temporaryId,
    };
    setAction(cleaningCompany);
    contact.push(cleaningCompany);
  }
  if (formData.condo && Object.keys(formData.condo).length !== 0 && (formData.condo.companyName || formData.condo.number)) {
    let condoManagement = {
      type: 'Company',
      role: ['propertymgmtcompany_eco'],
      companyName: trimString(formData.condo.companyName) || 'Unknown',
      phoneNumber: {
        code: 'CA',
        number: changePhoneNumberFormat(formData.condo.number) || '999-999-9999',
      },
      id: formData.condo.id,
      temporaryId: formData.condo.temporaryId,
    };
    setAction(condoManagement);
    contact.push(condoManagement);
  }
  formData.contact = contact;
};

export const formatDwellingCode = (formData) => {
  formData.dwellingCode = JSON.parse(sessionStorage.getItem('thePolicy'))?.properties?.[0]?.dwellingCode || null;
};
